<jhi-modal [title]="title">
    <div class="modal-body">
        <div class="row pt-2">
            <div class="col"><span class="fw-bold">{{ 'study-editor.study-dataset.export-study-modal.format.heading.export-format' | translate | uppercase}}</span></div>
        </div>
        <div class="row pt-3">
            <div class="col">
                <span translate="study-editor.study-dataset.export-study-modal.format.description.export-format"></span>
            </div>
            <div class="col">
                <ng-select [items]="exportFormats" [(ngModel)]="selectedFormat" bindLabel="name" placeholder="{{'study-editor.study-dataset.export-study-modal.select-format' | translate}}" [clearable]="false" required>
                </ng-select>
            </div>
        </div>
        @if(!isEnvironmentsExport && !isStudySettingsExport) {
            <div class="row pt-3">
                <div class="col"><span class="fw-bold">{{ 'study-editor.study-dataset.export-study-modal.format.heading.data-collection-order' | translate | uppercase}}</span></div>
            </div>
            <div class="row pt-2">
                <div class="col">
                    <span translate="study-editor.study-dataset.export-study-modal.format.description.data-collection-order"></span>
                </div>
                <div class="col">
                    <ng-select [(ngModel)]="collectionOrderId" [clearable]="false" required>
                        <ng-option [value]="1">{{ 'study-editor.study-dataset.export-study-modal.format.description.data-collection-order.1' | translate}}</ng-option>
                        <ng-option [value]="2">{{ 'study-editor.study-dataset.export-study-modal.format.description.data-collection-order.2' | translate}}</ng-option>
                        <ng-option [value]="3">{{ 'study-editor.study-dataset.export-study-modal.format.description.data-collection-order.3' | translate}}</ng-option>
                    </ng-select>
                </div>
            </div>
        }
        @if(!isStudySettingsExport) {
            <div class="row pt-3">
                <div class="col"><span class="fw-bold">{{ 'study-editor.study-dataset.export-study-modal.format.heading.study-environment' | translate | uppercase}}</span></div>
            </div>
            <div class="row pt-2">
                <div class="col">
                    <span translate="study-editor.study-dataset.export-study-modal.format.description.study-environment"></span>
                </div>
            </div>
            @if (!isEnvironmentsExport) {
                <div class="row pt-2">
                    <div class="col">
                        <div class="form-check">
                            <input class="form-check-input" type="checkbox" id="includeSampleGenotypeValues"
                                   [(ngModel)]="includeSampleGenotypeValues">
                            <label class="form-check-label" for="includeSampleGenotypeValues">
                                <span translate="study-editor.study-dataset.export-study-modal.format.description.include-sample-genotype"></span>
                            </label>
                        </div>
                    </div>
                </div>
                @if (this.selectedFormat.name === 'Excel' && DATASET_TYPES_SUB_OBSERVATION_IDS.includes(currentDataset.datasetTypeId)) {
                    <div class="row pt-2">
                        <div class="col">
                            <div class="form-check">
                                <input class="form-check-input" type="checkbox" id="tranposeByPlot"
                                       [(ngModel)]="transposeByPlot">
                                <label class="form-check-label" for="tranposeByPlot">
                                    <span translate="study-editor.study-dataset.export-study-modal.format.description.transpose-by-plot"></span>
                                </label>
                            </div>
                        </div>
                    </div>
                }
                @if (this.selectedFormat.name === 'CSV') {
                    <div class="row pt-2">
                        <div class="col">
                            <div class="form-check">
                                <input class="form-check-input" type="checkbox" id="allInstancesInOneFile"
                                       [(ngModel)]="singleFile">
                                <label class="form-check-label" for="allInstancesInOneFile">
                                    <span translate="study-editor.study-dataset.export-study-modal.format.description.all-instances-in-one-file"></span>
                                </label>
                            </div>
                        </div>
                    </div>
                }
            }
            <div class="container-fluid px-0 pt-3">
                <jhi-study-instances-table-selector [studyInstanceItems]="datasetInstances" [selectAll]="true"></jhi-study-instances-table-selector>
            </div>
        }
    </div>
    <div class="modal-footer">
        <button type="button" class="btn btn-secondary" data-bs-dismiss="modal" (click)="backToDatasetOptionModal()">
            <span translate="back"></span>
        </button>
        <button (click)="export()" class="btn btn-primary" data-test="modalConfirmButton" [disabled]="isExporting">
            <span translate="study-editor.study-dataset.export-study-modal.export"></span>
        </button>
    </div>
</jhi-modal>
